import { useQuery } from "@tanstack/react-query";
import { fetchWholesaleMultiChannel } from "../services/wholesaleMultiChannelService";

export function useWholesaleMultiChannel(period: number) {
  return useQuery({
    queryKey: ["wholesale-multiChannel", period],
    queryFn: () => fetchWholesaleMultiChannel(period),
    staleTime: 1000 * 60 * 5, // 5 mins
  });
}
